import { render, staticRenderFns } from "./split-signup.html?vue&type=template&id=353be2d8&scoped=true&external"
import script from "./split-signup.js?vue&type=script&lang=js&external"
export * from "./split-signup.js?vue&type=script&lang=js&external"
import style0 from "./split-signup.scss?vue&type=style&index=0&id=353be2d8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353be2d8",
  null
  
)

export default component.exports